import type Phaser from 'phaser';
import { ANIMATION } from '@/config/balance.config';

/**
 * Fallback intensywności shake'a per typ `destroyFx` — używany gdy dany
 * `destructibleId` nie ma własnego, strojonego wpisu w `ANIMATION.cameraShake`
 * (która historycznie ma TYLKO destruktyble meadow). Dzięki temu pozostałe biomy
 * (mountain / starwars / pixel / ocean) oraz każdy przyszły biom też trzęsą
 * kamerą przy zniszczeniu, skalując siłę wg „ciężkości" obiektu:
 *   coin (kupki) → lekki, wood (skrzynie) → średni, stone → mocny, crystal → max.
 */
const FX_FALLBACK_SHAKE: Record<string, { intensity: number; durationMs: number }> = {
  coin: { intensity: 0.004, durationMs: 100 },
  wood: { intensity: 0.006, durationMs: 150 },
  stone: { intensity: 0.010, durationMs: 220 },
  crystal: { intensity: 0.015, durationMs: 350 },
};

/**
 * Camera shake o intensywności dopasowanej do zniszczonego obiektu.
 * Kolejność: strojony preset per-id (`ANIMATION.cameraShake`, meadow) → fallback
 * per `destroyFx` (`FX_FALLBACK_SHAKE`) → brak (no-op, gdy nie znamy żadnego).
 */
export function shakeForDestructible(
  scene: Phaser.Scene,
  destructibleId: string,
  destroyFx?: string,
): void {
  const preset =
    ANIMATION.cameraShake[destructibleId] ??
    (destroyFx ? FX_FALLBACK_SHAKE[destroyFx] : undefined);
  if (!preset) return;
  scene.cameras.main.shake(preset.durationMs, preset.intensity);
}
